import { DetailedHTMLProps, HTMLAttributes } from 'react';

import styles from './TableScroll.module.scss';


type TProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export function TableScroll(props: TProps) {
	const { children, ...restProps } = props;

	return (
		<div className={ styles.tableScroll } { ...restProps }>
			{ children }
		</div>
	);
}
